<template>
  <div id="InventoryReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Inventory As At Detail</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'inventoryReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'inventoryReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Inventory Report"
                  ref="inventoryReport"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-select-all="onSelectAll"
                  @on-selected-rows-change="selectionChanged"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :select-options="{
                      enabled: true,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "InventoryReport",
  metaInfo() {
            return {title: "Inventory Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: 'Warehouse Code',
                    field: 'physical_location',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                },
                {
                    label: 'Part Number',
                    field: 'item',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                },
                {
                    label: 'Part Description',
                    field: 'item_desc',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                },
                {
                    label: 'Item Category',
                    field: 'catCode',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                },
                {
                    label: 'Mfg',
                    field: 'mfgCode',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                },
                {
                    label: 'Inv Source Date',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'Inv Update Date',
                    field: 'updated_at',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'Qty On Hand',
                    field: 'quantity',
                    filterable: true,
                    fpFieldType:"integer",
                    type:'number',
                    hidden:false,
                },
                 {
                    label: 'Average Cost',
                    field: 'base_price',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                },
                {
                    label: 'Value As At',
                    field: 'value',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    sortable:false,
                },
                {
                    label: 'Facility Code',
                    field: 'location',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                },
                {
                    label: 'Region Code',
                    field: 'region_code',
                    filterable: false,
                    hidden:false,
                    fpFieldType:"text",
                    sortable: false,
                },
                {
                    label: 'Last Date Used',
                    field: 'last_date_at',
                    filterable: false,
                    fpFieldType:"custom_date",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Last Transaction Type',
                    field: 'transaction_type',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Adjustment','Bin Move','Issue - Pick List','Merge','Miscellaneous Part','Physical Count Adjustment','Purchase receipt','Receiver Adjustment','Requisition','Retire','Return To Stock','Return To Supplier','Sublet Part','Transfer'], // dropdown (with selected values) instead of text input
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'As At Date',
                    field: 'as_at_date',
                    filterable: false,
                    hidden:true,
                    fpFieldType:"custom_date",
                    sortable:false
                },
                {
                    label: 'As Of Year',
                    field: 'as_of_year',
                    filterable: false,
                    hidden:true,
                    fpFieldType:"year",
                    sortable:false
                },
                {
                    label: 'As Of Period',
                    field: 'as_of_period',
                    filterable: false,
                    hidden:true,
                    fpFieldType:"period",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [1,2,3,4,5,6,7,8,9,10,11,12], // dropdown (with selected values) instead of text input
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },


            ],
    batchProcess:0,
    batchNum:"",



  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'inventory_as_at_detail_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.inventoryReport.unselectAllInternal();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['inventoryReport'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['inventoryReport'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/inventory-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            console.log('success');

            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;

            } else {
              if (data.content.row != undefined) {
                console.log("data.content.log");
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'inventory-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/InventoryReport.vue